module.exports = __webpack_public_path__ + "static/media/fuel-icon.039c1bb6.svg";